import { useSentinelMetrics } from '@/api/queries'
import { KpiCard } from '@/features/cockpit/KpiCard'
import { compactNumber, percent } from '@/lib/format'

export function SentinelKpi({ className }: { className?: string }) {
  const { data, isLoading } = useSentinelMetrics()
  const failed = data ? 100 - data.successRatio : undefined

  return (
    <KpiCard
      className={className}
      title="Sentinel · last 24h"
      loading={isLoading}
      headline={[
        { value: data ? compactNumber(data.totalRequests) : '–', label: 'requests' },
        { value: data?.customers ?? '–', label: 'customers' },
      ]}
      stats={[
        { label: 'Success', value: percent(data?.successRatio, 1), tone: data ? (data.successRatio >= 90 ? 'ok' : data.successRatio >= 70 ? 'warn' : 'danger') : undefined },
        { label: 'Failed', value: percent(failed, 1), tone: failed !== undefined && failed > 10 ? 'danger' : 'info' },
      ]}
    />
  )
}
